export default __webpack_public_path__ + "static/media/victor-savevsky.ef9acde2.png";